

exports.__esModule = true;
var FptiEventType = exports.FptiEventType = {
    Impression: 'im', // User saw something
    Click: 'cl', // User interacted with something (either by clicking/tapping)
    Available: 'av', // Something loaded on the screen. This is not the same as impression as something could load.
    Activity: 'ac' // Catch-all event for events happening to the user. This is usually reserved for silent decisions, rerouting, toasts, etc.
};


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/constants.js
// module id = ./pages/xo-review/constants.js
// module chunks = main-code-split